import React, { useRef } from 'react';
import Draggable from 'react-draggable';
import { Paper } from '@mui/material';

const DraggablePaperComponent = (props) => {
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      handle={props.handle}
      cancel={'[class*="MuiDialogContent-root"], .need-interaction'}
    >
      <div ref={nodeRef}>
        <Paper {...props} />
      </div>
    </Draggable>
  );
};

export default DraggablePaperComponent;
